<div class="container">
  <span class="label">Скрыть базис</span>
  <span class="icon"></span>
</div>
